<template>
  <div>
    <div v-if="status === 0">
      <van-cell-group style="padding:16px">
        <van-cell
          title="支付金额"
          center
          style="padding-bottom:24px"
          value-class="pay-price"
          title-style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #333333;"
        >
          ￥{{ pendingPaymentAmount }}
        </van-cell>
        <van-cell
          title="微信支付"
          title-style="font-size:18px;flex:none;margin-left:12px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #333333;"
          value-class="radio"
          size="large"
          center
          :border="false"
          label="推荐微信小程序使用"
          style="padding:25px;box-sizing:border-box"
        >
          <template #icon>
            <van-icon name="wechat-pay" color="#34bd36" size="32" />
          </template>
          <van-radio-group v-model="payMethod">
            <van-radio
              name="1"
              icon-size="24px"
              label-position="left"
              checked-color="#c6a560"
            ></van-radio>
          </van-radio-group>
        </van-cell>
      </van-cell-group>
      <van-cell-group
        v-for="(item, idx) in couponInfos"
        v-bind:key="idx"
        style="margin-top:8px"
      >
        <van-cell
          title="卡券编码"
          center
          :border="false"
          title-class="cell-title"
          value-class="cell-value"
        >
          {{ item.couponCode }}
        </van-cell>
        <van-cell
          title="指定商品"
          center
          :border="false"
          title-class="cell-title"
          value-class="cell-value"
        >
          {{ item.designatedGoods }}
        </van-cell>

        <van-cell
          title="卡券日期"
          :value="item.startTime + '至' + item.endTime"
          title-class="cell-title"
          value-class="cell-value"
          :border="false"
          center
        ></van-cell>
      </van-cell-group>
      <van-cell-group>
        <van-cell
          title="激活卡片后，用户只可在小程序官方商城兑换该商品"
          title-style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #DD5F58"
        ></van-cell>
      </van-cell-group>
      <van-button
        style="width:343px;height:40px;left:50%;transform:translateX(-50%);margin-top:24px"
        color="#c6a560"
        @click="pay"
        >确认支付</van-button
      >
    </div>
    <div v-else-if="status === 1">
      <div class="pay-status">
        <van-icon name="checked" size="48px" color="#33B02F"></van-icon>
        <div class="status-name">激活成功</div>
        <div class="status-desc">
          提货卡售出成功7天内顾客可进行退款，超过7天不予退款
        </div>
        <van-button class="back-btn" @click="back">返回提货卡</van-button>
      </div>
    </div>
    <div v-else-if="status === 2">
      <div class="pay-status">
        <van-icon name="clear" size="48px" color="#D0021B"></van-icon>
        <div class="status-name">激活失败</div>
        <div class="status-desc">支付异常，请重新支付</div>
        <div class="status-desc">{{ msg }}</div>
        <van-button class="back-btn" @click="back">返回提货卡</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiPost, browser, openInWebview } from "@/api/common";
import wx from "weixin-jsapi";
import { queryPost } from "../../api/common";
export default {
  data() {
    return {
      couponInfos: [],
      payMethod: "1",
      appId: "",
      openId: window.sessionStorage.getItem("openId"),
      secret: "",
      code: "",
      status: 0,
      urlNow: "",
      msg: "",
      resCode: "",
      couponIds: "",
      outTradeNo: "",
      isAndroid: false,
      isIos: false
    };
  },
  created() {
    if (this.openId === null || this.openId === "") {
      console.log("非微信浏览器");
    }
    this.couponInfos = this.$route.query.coupons;
    console.log(this.couponInfos);
    let pendingPaymentAmount = 0;
    const couponList = this.couponInfos;
    for (let i = 0; i < couponList.length; i++) {
      const coupon = couponList[i];
      if (coupon.pendingPaymentAmount) {
        pendingPaymentAmount += coupon.pendingPaymentAmount;
      } else {
        const prepayAmount = coupon.prepayAmount ? coupon.prepayAmount : 0;
        pendingPaymentAmount += coupon.couponPrice - prepayAmount;
      }
    }
    this.pendingPaymentAmount = pendingPaymentAmount.toFixed(2);
  },
  mounted() {
    window.updatePayResult = this.updatePayResult;
  },
  methods: {
    getCodeApi() {
      //获取code
      this.urlNow = encodeURIComponent(window.location.href);
      let url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.appId +
        "&redirect_uri=" +
        this.urlNow +
        "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
      window.location.href = url;
    },

    /**
     * 获取URL参数
     * @returns {Object}
     */
    getUrlCode() {
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },

    //获取appid和appSecrect
    async getAppId() {
      const res = await apiPost("mem/weiChatApplets/getWeChatAppId");
      const appid = res.data.data.results.appId;
      const secret = res.data.data.results.secret;
      this.appId = appid;
      this.secret = secret;
    },

    async loadPay() {
      var that = this;
      await this.getAppId();

      this.code = this.getUrlCode().code; // 截取code

      if (this.code == null || this.code === "") {
        this.getCodeApi();
      } else {
        queryPost("mem/weiChatApplets/getWeChatOpenId", {
          code: this.code
        })
          .then(res => {
            const data = JSON.parse(res.data.data.results);
            if (
              data.openid == null ||
              data.openid == "" ||
              data.openid == undefined
            ) {
              this.getCodeApi();
            }
            that.openId = data.openid;
          })
          .catch();
      }
    },

    pay() {
      let that = this;
      let url = "mem/weiChatApplets/getWeChatPaymentParameters";
      let currentUrl = window.location.href.split("#")[0];
      const ids = [];
      for (let i = 0; i < this.couponInfos.length; i++) {
        const coupon = this.couponInfos[i];
        ids.push(coupon.id);
      }
      this.couponIds = ids.toString();

      let params = {
        couponId: this.couponIds,
        url: currentUrl,
        openId: this.openId
      };
      const isWebView = openInWebview();
      const isAndroid =
        isWebView && browser.versions.mobile && browser.versions.android;
      const isIos =
        isWebView && browser.versions.mobile && browser.versions.ios;
      this.isAndroid = isAndroid;
      this.isIos = isIos;
      if (isAndroid || isIos) {
        params.isAppPay = true;
      }
      apiPost(url, params).then(res => {
        if (res.data.code === "0000") {
          let data = res.data.data.results;
          let outTradeNo = data.outTradeNo;
          that.outTradeNo = outTradeNo;
          if (!data.sign) {
            that.updateCouponAcive(outTradeNo);
            return;
          }
          //传递android支付参数所需要的参数
          const payParams = JSON.stringify(data);
          if (isAndroid) {
            window.injectedObject.startFunction(payParams);
          }
          //传递ios支付参数所需要的参数
          if (isIos) {
            window.webkit.messageHandlers.sendPayParam.postMessage(payParams);
          }

          console.log("data:" + data);
          wx.config({
            debug: false, // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
          });

          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: ["chooseWXPay"],
              success: function() {
                console.log("config seccess");
              },
              fail: function() {
                console.log("config fali");
              }
            });
            wx.chooseWXPay({
              timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
              package: data.wxPackage, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.sign, // 支付签名
              success: function() {
                that.updateCouponAcive(that.outTradeNo);
              },
              fail: function() {
                that.status = 2;
              }
            });
          });
          wx.error(err => {
            alert(err);
          });
        }
      });
    },
    updateCouponAcive: function() {
      let that = this;
      let data = {
        couponId: this.couponIds,
        paymentMerchantOrderNo: that.outTradeNo
      };
      if (that.isAndroid || that.isIos) {
        data.isAppPay = true;
      }
      apiPost("order/couponBusiness/activateCoupon", data).then(res => {
        if (res.data.code === "0000") {
          that.status = 1;
        } else {
          that.msg = res.data.msg;
          that.resCode = res.data.code;
          that.status = 2;
        }
      });
    },

    back() {
      this.$router.replace({ path: "/couponList", query: {} });
    },
    updatePayResult: function(status) {
      this.status = status;
      if (status == 1) {
        this.updateCouponAcive(this.outTradeNo);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.cell-value {
  text-align: left;
  margin-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.cell-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  flex: none;
}
.cell-label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.pay-price {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #c59a56;
}
.radio {
  display: flex;
  flex-direction: row-reverse;
  text-align: right;
}
.pay-status {
  margin-top: 50px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .status-name {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d1d1d;
    margin-top: 16px;
    text-align: center;
  }
  .status-desc {
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    text-align: center;
  }
  .back-btn {
    width: 110px;
    height: 34px;
    margin-top: 34px;
    text-align: center;
  }
}
</style>
